import React from 'react';
import { Link } from 'react-router';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { WCmsEventView } from '@zola/svc-web-api-ts-client';

// Components
import { Toggle } from '@zola/zola-ui/src/components/Toggle';

import {
  SortableItemContainer,
  StyledReorderIcon,
} from 'components/manage/website/entities/EditPageCommon/EditPageSortableList/EditPageSortableList.styles';

type RsvpSortableItemProps = {
  rsvp: WCmsEventView;
  id: string;
  onEdit: (event: WCmsEventView, ref?: React.MutableRefObject<null>) => void;
  updateEvent: (e: WCmsEventView, ref?: React.MutableRefObject<null>) => void;
};

const RsvpSortableItem = ({
  rsvp = {},
  id,
  onEdit,
  updateEvent,
}: RsvpSortableItemProps): JSX.Element => {
  const {
    name = '',
    num_guests_attending = 0,
    num_guests_declined = 0,
    num_guests_not_responded = 0,
  } = rsvp;

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  const numGuestsInvited = num_guests_attending + num_guests_declined + num_guests_not_responded;
  const trimmedRsvpName = name.length > 30 ? `${name.slice(0, 30)}...` : name;
  const isOnlineRsvpOn = rsvp.collect_rsvps;
  const toggleLabel = isOnlineRsvpOn ? 'Online RSVP On' : 'Online RSVP Off';

  return (
    <SortableItemContainer
      className="list-item__sortable edit-page-entity-item entity-item--rsvp"
      ref={setNodeRef}
      style={style}
      isDragging={isDragging}
    >
      <StyledReorderIcon width={24} height={24} {...listeners} {...attributes} title="" />
      <div className="event__details entity-details">
        <h4 className="event__title-section">
          <span className="event__title">{trimmedRsvpName}</span>
          <span className="event__edit-btn" onClick={() => onEdit(rsvp)}>
            Edit
          </span>
        </h4>
        <div className="event__rsvp-info">
          <Toggle
            input={{
              value: isOnlineRsvpOn,
              onChange: () => updateEvent({ ...rsvp, collect_rsvps: !isOnlineRsvpOn }),
            }}
            label={toggleLabel}
            labelSide="right"
            className="event__toggle-rsvp"
          />
        </div>
        <div className="event__guests-info">
          <span
            className={`event__guests-invited ${numGuestsInvited < 1 ? 'no-guests-invited' : ''}`}
          >
            {numGuestsInvited} {numGuestsInvited === 1 ? 'guest' : 'guests'} invited
          </span>
          <Link
            className="event__manage-guests-link zola-ui link link-arrow"
            to="/wedding/manage/guests/build"
          >
            Manage Guests
          </Link>
        </div>
      </div>
    </SortableItemContainer>
  );
};

export default RsvpSortableItem;
